import * as React from 'react'

import { cn } from '../../utils/cn'

// Slot anchor for GroupToggle / GroupLabel / GroupCount / GroupIndent / GroupConnectorLines.
// Figma "Header — Expanded": 16px left / 8px right / 6px vertical padding, 8px between
// children (checkbox, trigger, suffix), input-soft divider. Pinned to 32px so a taller child
// (24px avatar, bordered trigger) cannot stretch the band. Callers add no inset or gap.
export default function GroupHeader({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  return (
    <div
      {...rest}
      className={cn(
        'tw:flex tw:items-center tw:gap-2 tw:h-8 tw:w-full tw:shrink-0 tw:select-none tw:py-1.5 tw:pl-4 tw:pr-2 tw:bg-sidebar tw:text-foreground tw:border-0 tw:border-b tw:border-solid tw:border-input-soft',
        className,
      )}
    >
      {children}
    </div>
  )
}
